<template>
    <div class="pp-footer">
        <!-- <div v-on:click="GoTop">跳到顶部</div> -->
        <section
            class="footer_you"
            v-if="isShowLink"
        >
            <figure class="zhong flex">
                <img src="../image/yq.png" />
                <figcaption>{{LinkName}}</figcaption>
                <figcaption
                    v-if="isShowRegist"
                    @click="goAgree"
                    style="margin-left: 2em;cursor: pointer; font-size: 10px;color: #333;"
                >
                    <p class="border-bott">《{{RegistName}}》</p>
                </figcaption>
            </figure>
            <ul>
                <li
                    v-for="(item, index) in frendList"
                    :key="index"
                >
                    <a
                        href="javascript:void(0)"
                        v-on:click="openUrl(item.Url)"
                    >{{ item.Title }}</a>
                </li>
            </ul>
        </section>

        <section class="footer_div">
            <article class="footer_box float zhong">
                <div class="footer_left">
                    <figure class="zhong flex">
                        <img src="../image/edu-add.png" />
                        <figcaption>企业地址</figcaption>
                    </figure>
                    <hgroup class="flex zhong">
                        <p>{{ webSet.Address }}</p>
                    </hgroup>
                    <div class="footer_fg flex zhong">
                        <div class="footer_pic flex zhong">
                            <img src="../image/edu-tel.png" />
                            <p>
                                服务热线:
                                <span>{{ webSet.Phone }}</span>
                            </p>
                        </div>
                    </div>
                    <p>
                        {{ webSet.CopyRight }}，All Rights Reserved 备案号:
                        <a
                            href="javascript:void(0)"
                            v-on:click="openUrl(webSet.RecordUrl)"
                        >{{ webSet.RecordNo }}</a>
                    </p>
                </div>
                <figure
                    class="footer_qr"
                    v-if="codePic"
                ><img :src="codePic" /></figure>
            </article>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ppFooter',
    data() {
        return {
            frendList: [],
            webSet: {},
            codePic: '',
            isShowLink: false,
            isShowRegist: false,
            LinkName: false,
            RegistName: false
        };
    },
    components: {},
    mounted() {
        this.GetFrendLink();
        this.GetWebSet();
        this.GetCode();
        this.GetFrendLinkStatus();
    },
    methods: {
        GoTop: function () {
            console.log(111);
            document.body.scrollTo(0, 0);
        },
        // 用户协议
        goAgree() {
            this.$router.push('/agree');
        },
        // 获取友情链接
        GetFrendLink: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetFrendLink',
                'GET', {},
                function (res) {
                    if (res.code === 0) {
                        that.frendList = res.data;
                    }
                },
                function (res) { }
            );
        },
        // 获取网站配置
        GetWebSet: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetWebSet',
                'GET', {},
                function (res) {
                    if (res.code === 0) {
                        that.webSet = res.data;
						that.$store.state.user.cardSaleStatus = res.data.CardSale;
                    }
                },
                function (res) { }
            );
        },
        // 获取二维码
        GetCode: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetPagePicture',
                'GET', {},
                function (res) {
                    if (res.code === 0) {
                        var list = res.data;
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].Position === 4) {
                                that.codePic = list[i].CoverStr;
                            }
                        }
                    }
                },
                function (res) { }
            );
        },
        // 获取友情链接上下线状态
        GetFrendLinkStatus: function () {
            var that = this;
            that.$api.HtppRequest(
                'WebsiteSet/GetProjectSet',
                'GET', {},
                function (res) {
                    if (res.code === 0) {
                        var list = res.data;
                        for (var i = 0; i < list.length; i++) {
                            if (list[i].type === 7) {
                                that.isShowLink = list[i].IsPublish;
                                that.LinkName = list[i].Name;
                            } else if (list[i].type === 8) {
                                that.isShowRegist = list[i].IsPublish;
                                that.RegistName = list[i].Name;
                            }
                        }
                    }
                },
                function (res) { }
            );
        },
        openUrl: function (url) {
            window.open(url);
        }
    }
};
</script>
<style lang="scss" scoped>
.footer_left > p {
    font-size: 12px;
    color: #fff;
    margin-top: 10px;
}

.footer_left > p a {
    font-size: 12px;
    color: #fff !important;
    margin-top: 10px;
}

.footer_pic p {
    font-size: 14px;
}

.footer_pic p span {
    font-size: 14px;
    font-weight: bold;
}

.footer_pic img {
    width: 30px;
    height: 30px;
    margin-right: 0.5em;
}

.footer_pic {
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 6px;
    padding: 10px 15px;
    color: #fff;
    margin-right: 30px;
}

.footer_fg {
    overflow: hidden;
    margin: 15px 0;
}

.footer_left hgroup p:first-child {
    margin-right: 0.5em;
}

.footer_left hgroup p {
    font-size: 14px;
    color: #fff;
}

.footer_left hgroup {
    overflow: hidden;
    display: flex;
    margin-left: 30px;
    margin-top: 10px;
}

.footer_left figure figcaption {
    font-size: 14px;
    color: #fff;
    margin-left: 5px;
}

.footer_left figure img {
    width: 24px;
    height: 24px;
    display: block;
}

.footer_left {
    overflow: hidden;
    width: calc(100% - 420px);
}

/*footer_left*/

.footer_qr figcaption {
    font-size: 14px;
    color: #fff;
    display: block;
    text-align: center;
    line-height: 30px;
}

.footer_qr img {
    display: block;
    width: 130px;
    max-height: 170px;
}

.footer_qr {
    width: 130px;
    background-color: #46646f;
}

/*footer_qr*/

.footer_box {
    overflow: hidden;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
}

.footer_div {
    overflow: hidden;
    background-color: #183d4b;
    padding: 10px 0;
}

/*footer_div*/

.footer_you ul li:hover {
    opacity: 0.7;
}

.footer_you ul li:last-child::after {
    width: 0;
}

.footer_you ul li::after {
    content: '';
    width: 1px;
    height: 16px;
    background-color: #333;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -8px;
    z-index: 1;
}

.footer_you ul li a {
    display: block;
    font-size: 14px;
    color: #333;
}

.footer_you ul li {
    float: left;
    overflow: hidden;
    padding: 0 40px;
    position: relative;
}

.footer_you ul {
    overflow: hidden;
    margin-top: 10px;
}

.footer_you figure figcaption {
    font-size: 14px;
}

.footer_you figure img {
    display: block;
    width: 18px;
    height: 18px;
    margin-right: 10px;
}

.footer_you {
    overflow: hidden;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
}

.pp-footer {
    overflow: hidden;
    background-color: #e6e6e6;
}

.footer_pic .border-bott {
    border-bottom: 1px solid #fff;
    cursor: pointer;
}
</style>
